import { InMemoryHeader, InMemoryString, InMemoryDecimal, InMemoryInteger } from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";

const headers = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Member Group",
    type: new InMemoryString("MemberGroup", {
      getString: (item) => translate2(item.MemberGroup, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.amount_of_deductible_for_re_initiation",
    type: new InMemoryInteger("AmountOfDeductibleForReInitiation", {
      getString: (item, type) => {
        const value = item.AmountOfDeductibleForReInitiation;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(0)
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.hours_c",
    type: new InMemoryDecimal("Hours", {
      getString: (item, type) => {
        const value = parseFloat(item.CommencementRule.Hours);
        if (value === null || value === undefined ||  isNaN(value)) {
          return "";
        }
        return value.toFixed(2)
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.rolling_period_months_c",
    type: new InMemoryInteger("RollingPeriodMonths", {
      getString: (item, type) => {
        const value = parseInt(item.CommencementRule.RollingPeriodMonths);
        if (value === null || value === undefined || isNaN(value)) {
          return "";
        }
        return value
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.eligibility_months_c",
    type: new InMemoryInteger("EligibilityMonths", {
      getString: (item, type) => {
        const value = parseInt(item.CommencementRule.EligibilityMonths);
        if (value === null || value === undefined || isNaN(value)) {
          return "";
        }
        return value
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.hours_r",
    type: new InMemoryDecimal("Hours", {
      getString: (item, type) => {
        const value = parseFloat(item.ReinstatementRule.Hours);
        if (value === null || value === undefined ||  isNaN(value)) {
          return "";
        }
        return value.toFixed(2)
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.rolling_period_months_r",
    type: new InMemoryInteger("RollingPeriodMonths", {
      getString: (item, type) => {
        const value = parseInt(item.ReinstatementRule.RollingPeriodMonths);
        if (value === null || value === undefined || isNaN(value)) {
          return "";
        }
        return value
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plan_builder.eligibility_hour_bank_settings.eligibility_months_r",
    type: new InMemoryInteger("EligibilityMonths", {
      getString: (item, type) => {
        const value = parseInt(item.ReinstatementRule.EligibilityMonths);
        if (value === null || value === undefined || isNaN(value)) {
          return "";
        }
        return value
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default headers;
